/* SMOKE-TEST: logs when .card-quick-add submits */
document.addEventListener('submit', e => {
  if (e.target.closest('form.card-quick-add')) {
    e.preventDefault();
    console.log('🎉 SMOKE-TEST FIRED');
  }
}, true);
